import React from "react";
import styled from "styled-components";

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    min-height: 0;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    gap: 20px;
`;

type PaneContentProps = {
    children?: React.ReactNode;
};

export default function PaneContent({ children }: PaneContentProps) {
    return <ContentContainer>{children}</ContentContainer>;
}
